import { useStoreSearchContext } from "../../../storeSearch.context";
import { SwitchTabComponent } from "./switchTab.component";

export const SwitchTab = () => {
    const { tab, setTab } = useStoreSearchContext();

    const openList = () => setTab("list");
    const openMap = () => setTab("map");

    return (
        <SwitchTabComponent
            tab={tab}
            openList={openList}
            openMap={openMap}
        />
    );
};
